import { createSlice } from "@reduxjs/toolkit";

// Manufacturing records only: the product has no packaging-record view, so the module is fixed.
const initialModule = "prod";

const moduleChangeSlice = createSlice({
  name: "moduleView",
  initialState: initialModule,
  reducers: {
    setChangeModule: (state, action) => {
      localStorage.setItem("moduleView", action.payload); // Save to localStorage
      return action.payload;
    },
  },
});

export const { setChangeModule } = moduleChangeSlice.actions;
export default moduleChangeSlice.reducer;
